import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import toastNotify from "../../utils/ToastNotify";
import { convertToBase64 } from "../../utils/Common";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import JSZip from "jszip";
import { getImageMimeType } from "../../utils/Helper";
import SelectField from "../../componants/textField/SelectField";
import TextField from "../../componants/textField/TextField";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import { BiFileBlank, BiHomeAlt, BiLayer, BiLeftArrowAlt, BiLink, BiX } from "react-icons/bi";

const CreateTicket = () => {
  const [departmentProduct, setDepartmentProduct] = useState([]);
  const [multiFile, setMultiFile] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const editorRef = useRef();
  const location = useLocation();
  const data = location.state || {};

  const attanchmentRef = useRef(null);

  const handleProductChange = (selectedOption) => {
    const PerticularProductData = departmentProduct.filter((val) => {
      return val.ITEM_CD === selectedOption;
    });
    setSelectedProduct(PerticularProductData); // Set selected product correctly
  };

  useEffect(() => {
    if (data?.ProductCode?.ITEM_CD) {
      handleProductChange(data.ProductCode.ITEM_CD);
    }
  }, [data, departmentProduct]);


  const editorConfiguration = {
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "insertTable",
        "|",
        "undo",
        "redo",
      ],
    },
  };

  const handleMultiFile = (e) => {
    e.preventDefault();
    const files = e.target.files;
    let fileSize = 0;
    const AttechmentSize = 5;

    if (files.length > 0) {
      Array.from(files).forEach((file) => {
        fileSize = parseFloat(fileSize) + parseFloat((file.size / 1048576).toFixed(2));
      });

      if (Number(fileSize) > Number(AttechmentSize)) {
        setMultiFile([]);
        return toastNotify(`File size less then ${AttechmentSize} MB`, 'error');
      } else {
        Array.from(files).forEach((file) => {
          const reader = new FileReader();

          reader.onloadend = () => {
            let mimeType;
            mimeType = getImageMimeType(reader);

            if (mimeType === 'unknown') {
              return toastNotify('Invaid file format', 'error');
            }
            setMultiFile((prevent) => [...prevent, file]);
          };
          reader.readAsArrayBuffer(file);
        });
      }
    };
  };

  // in this function convert zip and base64
  const generateZipFile = async () => {
    const zip = new JSZip();
    if (multiFile.length > 0) {
      multiFile.forEach((items) => {
        zip.file(items.name, items);
      });
      const content = await zip.generateAsync({ type: "blob" });
      const base64 = await convertToBase64(content);
      return base64.split(",")[1];
    } else {
      return "";
    }
  };

  // Function to get the selected file size
  const getSelectedFileSize = () => {
    if (multiFile.length > 0) {
      const fileSize = multiFile.reduce((acc, file) => acc + file.size, 0);
      return fileSize;
    } else {
      return 0;
    }
  };

  const getDepartmentProduct = async () => {
    try {
      dispatch(handleLoader(true));
      const data = {
        CAT_CD: "",
        FLAG: "Y",
      };
      const config = {};
      await makeRequest(
        "POST",
        urls.getDashboardProductList,
        data,
        config
      ).then((result) => {
        if (result?.STATUS === "0") {
          const response = result.RESPONSE;
          setDepartmentProduct(response);
        } else if (result.STATUS !== "0") {
          setDepartmentProduct([]);
        }
      });
    } catch (error) {
      // submitErrorLogToApi(error);
    } finally {
      dispatch(handleLoader(false));
    }
  };

  useEffect(() => {
    getDepartmentProduct();
  }, []);

  async function handleSubmit(val, { resetForm }) {
    try {
      dispatch(handleLoader(true));
      var getBase64 = await generateZipFile();
      const payload = {
        DEPARTMENT_CD: "1",
        PRODUCT_CD: val.productValue,
        SUBJECT: val.subject,
        DESCRIPTION: val.discription,
        FILE_B64: getBase64,
        FILE_SIZE: getSelectedFileSize().toString(),
        PRIORITY: "N",
        CLASSIFICATION: "C",
      };

      const config = {};
      await makeRequest("POST", urls.setTicket, payload, config).then(
        (result) => {
          if (result.STATUS === "0") {
            toastNotify(result.MESSAGE, "success");
            navigate("/support");
          } else {
            toastNotify(result.MESSAGE, "error");
          }
        }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(handleLoader(false));
    }
  }

  const initialVal = {
    productValue: data?.ProductCode?.ITEM_CD ?? "",
    productLabel: data?.ProductCode?.ITEM_NM ?? "",
    subject: "",
    uploadFile: "",
    discription: "",
  };

  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row date-time container-top">
          <div className="col-lg-12 col-md-12 col-12 mb-2">
            <div className="d-flex justify-content-between">
              <div className="pb-2">
                <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
                <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
                  Dashboard
                </NavLink>
                <span className="text-secondary d-none d-md-inline"> / </span>
                <NavLink to="/support" className="text-secondary d-none d-md-inline">
                  Support /
                </NavLink>
                <span className="navigation-header-text ps-1">
                  Create Ticket
                </span>
              </div>
              <Button type="button" variant="warning" className="btn-sm" onClick={() => {
                if (data?.ProductCode === undefined) {
                  navigate("/support");
                } else {
                  navigate("/products");
                }
              }} >
                <BiLeftArrowAlt className="text-lg me-1" />
                Back
              </Button>
            </div>
          </div>
        </div>


        <div className="card">
          <div className="card-body">
            <Formik
              initialValues={initialVal}
              validationSchema={Yup.object().shape({
                productValue: Yup.string().required("Product is required field"),
                subject: Yup.string().required("Subject is required field"),
                discription: Yup.string().required("Description is required field"),
              })}
              onSubmit={handleSubmit}
            >
              {({ setFieldValue, values, handleChange, handleBlur, setFieldTouched }) => {
                return (
                  <Form>
                    <Row>
                      <Col md={8}>
                        <Row>
                          <Col md={6} className="mb-3">
                            <SelectField
                              name="product"
                              tabIndex={2}
                              options={[
                                { value: "", label: "Select Product" },
                                ...departmentProduct.map((items) => ({
                                  value: items.ITEM_CD, label: items.ITEM_NM
                                }))]}
                              required
                              placeholder="Product"
                              value={values.productValue !== "" && {
                                value: values.productValue,
                                label: values.productLabel
                              }}
                              onChange={(e) => {
                                setFieldValue("productValue", e?.value);
                                setFieldValue("productLabel", e?.label);
                                handleProductChange(e.value);
                              }}
                              onBlur={() => {
                                setFieldTouched("productValue", true);
                              }}
                            />
                            <ErrorMessage name="productValue" className='error-msg' component="div" />
                          </Col>
                          {/* <div className="row">
                            <div className="col-lg-5 col-md-6 col-12 mb-3">
                              <SelectField
                                name="priority"
                                tabIndex={2}
                                options={[
                                  { value: "", label: "Select Product" },
                                  ...[{ value: "H", label: "High" },
                                  { value: "N", label: "Normal" },
                                  { value: "L", label: "Low" }]
                                ]}
                                required
                                placeholder="Priority"
                                value={values.priorityValue !== "" && {
                                  value: values.priorityValue,
                                  label: values.priorityLabel
                                }}
                                onChange={(e) => {
                                  setFieldValue("priorityValue", e?.value);
                                  setFieldValue("priorityLabel", e?.label);
                                }}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="priorityValue" className='error-msg' component="div" />
                            </div>

                            <div className="col-lg-5 col-md-6 col-12 mb-3">
                              <SelectField
                                name="classification"
                                tabIndex={2}
                                options={[
                                  { value: "", label: "Select Product" },
                                  { value: "Q", label: "Query" },
                                  { value: "C", label: "Complaint" },
                                  { value: "O", label: "Other" },
                                ]}
                                required
                                placeholder="Classification"
                                value={values.classificationValue !== "" && {
                                  value: values.classificationValue,
                                  label: values.classificationLabel
                                }}
                                onChange={(e) => {
                                  setFieldValue("classificationValue", e?.value);
                                  setFieldValue("classificationLabel", e?.label);
                                }}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="classificationValue" className='error-msg' component="div" />
                            </div>
                          </div> */}
                          <Col md={12}>
                            <div className="tick_sub mb-3">
                              <TextField
                                label="Subject"
                                name="subject"
                                id="subject"
                                required
                                tabIndex={10}
                                maxLength={100}
                                value={values.subject}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="subject" className='error-msg' component="div" />
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="tick_sub mb-3">
                              <label
                                htmlFor="discription"
                                className="form-label"
                              >
                                Description
                                <span className="text-danger h5"> *</span>
                              </label>
                              <CKEditor
                                editor={ClassicEditor}
                                config={editorConfiguration}
                                name="discription"
                                ref={editorRef}
                                onChange={(event, editor) => {
                                  const data = editor?.getData?.();
                                  if (data) {
                                    setFieldValue("discription", data);
                                  }
                                }}
                              />
                              <ErrorMessage name="discription" className='error-msg' component="div" />
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="tick_sub mb-3">
                              <label
                                htmlFor="uploadFile"
                                className="form-label"
                              >
                                Attachment
                              </label>
                              <input
                                type="file"
                                id="uploadFile"
                                name="attachFile"
                                accept=".jpg, .jpeg, .png, .pdf, .xlsx"
                                multiple
                                className="d-none"
                                ref={attanchmentRef}
                                onChange={(e) => {
                                  const selectFiles = e.target.files;
                                  setFieldValue("attachFile", selectFiles);
                                  handleMultiFile(e);
                                }}
                              />

                              <span
                                className="d-flex align-items-center"
                                onClick={() => attanchmentRef.current.click()}
                                style={{
                                  cursor: "pointer",
                                  border: "1px solid #d9dee3",
                                  borderRadius: "5px",
                                }}
                              >
                                <div
                                  className=" d-flex justify-content-center align-items-center me-2 border-oragne"
                                  style={{
                                    width: 35,
                                    height: 35,
                                    background: "#d9dee3",
                                  }}
                                >
                                  <BiLink />
                                </div>
                                <div>
                                  <span
                                    className="text-sm mb-0"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Attach a file Up to 5 MB
                                  </span>
                                </div>
                              </span>

                              <div
                                className="mt-3"
                                style={{
                                  maxHeight: "150px",
                                  overflowY: "auto",
                                }}
                              >
                                {multiFile.map((file, id) => {
                                  const fileSize =
                                    file.size >= 1024
                                      ? (file.size / 1048576).toFixed(2) +
                                      " MB"
                                      : (file.size / 1024).toFixed(2) + " KB";
                                  return (
                                    <div
                                      key={id}
                                      className="d-flex align-items-center mt-3"
                                      style={{
                                        background: "#f9f9f9",
                                        padding: "5px",
                                        borderRadius: "5px",
                                      }}
                                    >
                                      {file.type.startsWith("image/") ? (
                                        <div
                                          className="border rounded-circle d-flex justify-content-center align-items-center me-3"
                                          style={{ width: 35, height: 35 }}
                                        >
                                          <img
                                            src={
                                              file
                                                ? URL.createObjectURL(file)
                                                : ""
                                            }
                                            alt={file.name}
                                            className="w-100 h-100 rounded-circle"
                                          />
                                        </div>
                                      ) : (
                                        <div
                                          className="  d-flex justify-content-center align-items-center me-3"
                                          style={{ width: 35, height: 35 }}
                                        >
                                          <BiFileBlank />
                                        </div>
                                      )}
                                      <div>
                                        <h5
                                          className="text-sm mb-1"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {file.name}
                                        </h5>
                                        <div
                                          className="text-sm text-slate-500"
                                          style={{ fontSize: "11px" }}
                                        >
                                          File Size : {fileSize}
                                        </div>
                                      </div>
                                      <button
                                        className=" btn btn-sm ms-auto"
                                        type="button"
                                        onClick={() => {
                                          let selectedFile = [...multiFile];
                                          selectedFile.splice(id, 1);
                                          setMultiFile(selectedFile);
                                        }}
                                      >
                                        <BiX className="text-danger text-lg" />
                                      </button>
                                    </div>
                                  );
                                })}
                                <ErrorMessage
                                  name="uploadFile"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <div className="mt-3 mb-2">
                          <Button
                            type="submit"
                            className="btn-sm"
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>

                      {/* **************** articles column **************** */}
                      <Col md={1} className="d-none d-md-block"></Col>
                      <Col md={3} className="d-none d-md-block">
                        <div className="">
                          <h5 className="text-base pb-2 mb-2 border-bottom">
                            <BiLayer className="me-2" />
                            Product Detail
                          </h5>
                          {selectedProduct && selectedProduct.length === 0 ? (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: "50vh" }}
                            >
                              <div className="">
                                <img
                                  src="/assets/images/No-data.jpg"
                                  alt=""
                                  style={{ width: "180px" }}
                                />
                                <p className="text-sm text-center pt-3">
                                  Product not Found
                                </p>
                              </div>
                            </div>
                          ) : (
                            <div>
                              {selectedProduct?.[0] ? (
                                <div className="product-detail">
                                  <div className="mb-2">
                                    {selectedProduct[0]?.ITEM_NM}
                                    <div className="text-primary text-xs">{selectedProduct[0]?.CAT_NM}</div>
                                  </div>

                                  <img
                                    src={selectedProduct[0]?.IMG}
                                    alt="Product-image"
                                    style={{ width: "100%", height: 130 }}
                                    className="card"
                                  />

                                  <p
                                    className="mt-2 text-sm text-slate-500"
                                    style={{ textAlign: "justify" }}
                                    dangerouslySetInnerHTML={{
                                      __html: showFullDescription
                                        ? selectedProduct[0]?.DESCRIPTIONS
                                        : selectedProduct[0]?.DESCRIPTIONS.slice(
                                          0,
                                          230
                                        ) + "...", // Show truncated description
                                    }}
                                  />
                                  {showFullDescription ? (
                                    <span
                                      className="text-link fw-light cursor-pointer text-primary"
                                      onClick={() => setShowFullDescription(false)}
                                    >
                                      Hide
                                    </span>
                                  ) : (
                                    <span
                                      className="text-link fw-light cursor-pointer text-primary"
                                      onClick={() => setShowFullDescription(true)}
                                    >
                                      View more
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ height: "50vh" }}
                                >
                                  <img
                                    src="/assets/images/noDataFound.png"
                                    alt=""
                                    style={{ width: "180px" }}
                                  />
                                </div>
                              )}
                              {/* <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: "40vh" }}
                              >
                                <div className="">
                                  <img
                                    src={selectedProduct[0]?.IMG}
                                    alt="Product-image"
                                    style={{ width: "180px" }}
                                    className="card"
                                  />
                                  <p className="text-sm text-center pt-3">
                                    Product Detail
                                  </p>
                                </div>
                              </div> */}
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div >
    </>
  );
};

export default CreateTicket;
